import { FC, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import Auth from 'store/auth'
import Button from 'components/parts/button/button'
import PopupBuyCourse from 'components/popups/popup-buy-course/popup-buy-course'
import useRegistration from 'hooks/useRegistration'
import MedpointYaBage from 'components/parts/medpoint-ya-bage/medpoint-ya-bage'

import A from 'utils/metrics/analytic'
import { PAYMENT_BTN_CLICK } from 'constants/analytic-data'
import { YA_PAY_MERCHANT_ID } from 'constants/data'
import { ICourseType } from 'constants/types/course.types'
import { popupName } from 'constants/auth/auth-data'
import { cutHashFromURL } from 'utils/getURLData'

import { FieldsNameVoc, DUPLICATE_ERROR } from 'constants/auth/profile-data'
import { PAYMENT_POPUP_QUERY, useConsultationPurchase } from './data'

import styles from './purchase.module.scss'

interface IPurchase {
  courseInfo: ICourseType
  outerPurchasePopHandler?: () => void
  outerMainPopHandler?: () => void
}

const salesFields = [FieldsNameVoc.fullName, FieldsNameVoc.phone, FieldsNameVoc.email]

const Purchase: FC<IPurchase> = ({ courseInfo, outerPurchasePopHandler, outerMainPopHandler }) => {
  const [innerPurchasePop, setInnerPurchasePop] = useState(false)
  const { isAuthorized } = Auth.useAuth()
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)
  const paymentValue = router.query[PAYMENT_POPUP_QUERY]
    ? String(router.query[PAYMENT_POPUP_QUERY])
    : ''

  const { onSubmitRegistration, error } = useRegistration()
  const { price } = courseInfo

  const { isButtonDisabled, getValues } = useConsultationPurchase(salesFields)
  const registrationHandler = async () => {
    const inputValues = getValues()
    A.setEvent(PAYMENT_BTN_CLICK)
    if (isAuthorized) {
      if (outerPurchasePopHandler) {
        outerPurchasePopHandler()
      } else {
        setInnerPurchasePop(true)
      }
      return
    }

    const code: number | undefined = await onSubmitRegistration(inputValues)

    if (code === 200 || code === 409) {
      if (outerPurchasePopHandler || outerMainPopHandler) {
        outerPurchasePopHandler?.()
        outerMainPopHandler?.()
      } else {
        setInnerPurchasePop(true)
      }
    }
  }

  useEffect(() => {
    const YaPay = (window as any).YaPay
    setTimeout(() => {
      YaPay.mountBadge(document.querySelector('#YAPayBage'), {
        type: 'bnpl',
        amount: String(price),
        size: 'm',
        variant: 'detailed',
        color: 'primary',
        merchantId: YA_PAY_MERCHANT_ID,
      })
    }, 0)
  }, [price])

  return (
    <div className={styles.purchase}>
      <div className={styles.title}>
        {isAuthorized ? 'Записаться на курс' : 'Войдите для записи на курс'}
      </div>
      {/* {!isAuthorized && (
        <div>
          <form id="form" className={styles.form}>
            <ControllerBaseInput
              control={control}
              name={FieldsNameVoc.fullName}
              errors={errors}
              noErrorOnTouch={clearErrors}
              rules={fullNameValidation}
            />
            <ControllerPhoneInput
              control={control}
              errors={errors}
              noErrorOnTouch={clearErrors}
              setValue={setValue}
            />
            <ControllerBaseInput
              control={control}
              name={FieldsNameVoc.email}
              errors={errors}
              noErrorOnTouch={clearErrors}
              rules={emailValidation}
            />
          </form>
        </div>
      )}

     */}
      {isAuthorized && (
        <div className={styles.priceWrapper}>
          <div className={styles.price}>{price} ₽</div>
          <div className={styles.yaBage}>
            <MedpointYaBage price={Number(price)} />
          </div>
        </div>
      )}
      {isAuthorized && (
        <div className={styles.infoPay}>
          Оплатите удобным для вас способом: банковской картой, в рассрочку или за счет средств ОМС
        </div>
      )}
      {!isAuthorized && (
        <Link href={`${path}#${popupName.registration}`}>
          <Button>Войти в аккаунт</Button>
        </Link>
      )}
      {isAuthorized && (
        <div className={styles.btnWrap}>
          <Button onClick={registrationHandler} disabled={isButtonDisabled}>
            Выбрать способ оплаты
          </Button>
        </div>
      )}

      {error && error !== DUPLICATE_ERROR && <p className={styles.errorResponse}>{error}</p>}
      {isAuthorized && (
        <p className={styles.memo}>
          Нажимая на кнопку “Выбрать способ оплаты”, я соглашаюсь на обработку персональных данных
        </p>
      )}
      {innerPurchasePop && (
        <PopupBuyCourse
          courseInfo={courseInfo}
          handleShowPopup={setInnerPurchasePop}
          paymentPopup={paymentValue}
        />
      )}
    </div>
  )
}

export default Purchase
